var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('identity-verification-form',{attrs:{"form-model":_vm.formModel,"person-title":_vm.locale.branches.theBranch,"view-mode":_vm.loading,"firms-only":true,"manager-social-id-required":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }